import { useEffect } from 'react'
import { withRouter, RouteComponentProps } from 'react-router-dom'

function ScrollToTop({ history }: RouteComponentProps) {
  useEffect(() => {
    const unListen = history.listen(() => {
      window.scrollTo({
        top: 0,
        left: 0,
        behavior: 'smooth',
      })
    })
    return () => {
      unListen()
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [])

  return null
}

export default withRouter(ScrollToTop)
